import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <img src="/PrediEdge.png" alt="PrediEdge Logo" style={{ width: 24, height: 24, borderRadius: 4 }} />
              PrediEdge
            </h3>
            <p>Professional Polymarket intelligence for serious traders.</p>
          </div>
          
          <div className="footer-section">
            <h4>Product</h4>
            <button className="footer-link" onClick={() => scrollToSection('features')}>
              Features
            </button>
          </div>

          <div className="footer-section">
            <h4>Resources</h4>
            <Link to="/blog" className="footer-link">
              Blog
            </Link>
          </div>
          
          <div className="footer-section">
            <h4>Get Started</h4>
            <a 
              href="https://app.prediedge.com/?utm_source=site&utm_medium=footer&utm_campaign=landing"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Launch App
            </a>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <Link to="/legal" className="footer-link">
              Legal & Disclaimers
            </Link>
            <Link to="/terms" className="footer-link">
              Terms of Service
            </Link>
            <Link to="/privacy" className="footer-link">
              Privacy Policy
            </Link>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 PrediEdge. All rights reserved.</p>
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
            <a 
              href="https://x.com/prediedge"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Follow us on X"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a
              href="https://discord.gg/agj3bcfJWe"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Join our Discord"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M20.317 4.369a19.79 19.79 0 00-4.885-1.515.074.074 0 00-.079.037c-.211.375-.444.864-.608 1.249-1.844-.276-3.68-.276-5.486 0-.164-.402-.413-.874-.625-1.249a.077.077 0 00-.079-.037 19.736 19.736 0 00-4.885 1.515.069.069 0 00-.032.027C1.51 9.093.76 13.61 1.093 18.079a.082.082 0 00.031.056c2.052 1.505 4.038 2.422 5.989 3.029a.078.078 0 00.084-.027c.461-.63.874-1.295 1.226-1.997a.076.076 0 00-.041-.105c-.652-.249-1.273-.549-1.872-.892a.076.076 0 01-.008-.126c.126-.095.252-.194.372-.295a.074.074 0 01.077-.01c3.927 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.009c.12.101.245.2.372.295a.076.076 0 01-.006.126 12.3 12.3 0 01-1.873.893.077.077 0 00-.04.104c.36.702.773 1.367 1.226 1.998a.078.078 0 00.084.027c1.962-.607 3.948-1.524 6-3.03a.08.08 0 00.031-.055c.5-6.837-1.115-11.314-4.73-13.683a.062.062 0 00-.031-.028zM8.68 15.328c-1.183 0-2.157-1.082-2.157-2.41 0-1.327.96-2.41 2.157-2.41 1.209 0 2.173 1.094 2.157 2.41 0 1.328-.96 2.41-2.157 2.41zm6.637 0c-1.183 0-2.157-1.082-2.157-2.41 0-1.327.96-2.41 2.157-2.41 1.208 0 2.172 1.094 2.157 2.41 0 1.328-.95 2.41-2.157 2.41z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 